import React, { useEffect, useRef, useState } from 'react'
import { Modal, ModalBody } from "react-bootstrap";
import ModalHeader from '../../../../../../../Setup/Shared/ModalHeader';
import { enumUtil } from '../../../../../../../../utils/Enum';
import { useSelector } from 'react-redux';
import NotificationHandler from '../../../../../../../../utils/NotificationHandler';
import isNull from '../../../../../../../../utils/NullChecking';
import { ServerRequestProtected, ServerRequestPublic } from '../../../../../../../../utils/ServerDataRequest';
import FormValidator from '../../../../../../../../utils/FormValidator';
import { format } from 'date-fns';
import Loader from '../../../../../../../shared/Loader/Loader';
import SuperSearchList from '../../../../../../../shared/SuperSearch/SuperSearchList';
import DropdownValueHandler from '../../../../../../../shared/SuperSearch/DropdownValueHandler';
import { Worker } from '@react-pdf-viewer/core';
import { Viewer } from '@react-pdf-viewer/core';
import { defaultLayoutPlugin } from "@react-pdf-viewer/default-layout";

const AddNewDocument = (props) => {
    const { isOpenDocument, onClose, documentModal, setDocumentModal, PatientDocumentID, setIsClose, onCancel } = props;

    // let IsEditAllowed = FindFirstChild('Patient','Document')?.IsAdd
    // let IsDeleteAllowed = FindFirstChild('Patient','Document')?.IsDeleted

    const defaultLayoutPluginInstance = defaultLayoutPlugin();
    const API_URL = enumUtil.controller.PATIENT
    let PateintIDR = useSelector(state => state.Open_Patient_Tab.find((pt) => pt.active === true));
    PateintIDR = PateintIDR?.data?.id
    let DropDowns = useSelector(state => state.GeneralDropDownsReducer);
    const API_URL_Wasabi = enumUtil.controller.Wasabi;
    // let {  } = { ...props }
    const [isLoading, setIsLoading] = useState(false)

    const [modalActive, setModalActive] = useState(false)
    const [pdfFile, setPdfFile] = useState(null);
    const [txtFile, setTxtFile] = useState(null);
    const [imgFile, setImgFile] = useState(null);

    const fileInputRef = useRef(null);
    let Document_Modal = {
        PatientID: PateintIDR + "",
        DocumentTypeID: '',
        FileName: '',
        Title: '',
        Description: '',
        UpdatedBy: '',
        UpdateDate: ''
        // ...documentModal,
        // File: '',
        // ReferedBy: '',
        // DocumentDateType: format(new Date(), 'MM/dd/yyy'),
        // DocumentType: '',
        // Provider: '',
        // Source: '',
    }
    let valModal = {}
    let ValidationModal = {
        FileNameVal: '',
        DocumentTypeVal: '',
        FileVal: '',
    }
    const [DocumetValidationModal, setDocumetValidationModal] = useState(ValidationModal)
    const [DocumetSaveUpdateModal, setDocumetSaveUpdateModal] = useState({})
    const [mainDocumentModal, setMainDocumentModal] = useState(Document_Modal);
    const [documentID, setDocumentID] = useState('');
    const [is, setIs] = useState(false);
    const [file, setfile] = useState('')
    const handleDocumentChange = (e) => {
        setIs(false)
        let { name, value } = e.target;
        // if (process.env.REACT_APP_ISUPPERCASE === "true") {
        //     value = value.toUpperCase()
        // }
        let modal = { ...mainDocumentModal };
        let saveModal = { ...DocumetSaveUpdateModal }
        modal[name] = value
        setMainDocumentModal(modal)
        for (var property in Document_Modal) {
            if (name === property) {
                saveModal[name] = value
            }
        }
        setDocumetSaveUpdateModal(saveModal)
    }
    const DocumentValidation = async () => {
        let ValidationModal = {
            FileNameVal: FormValidator(
                mainDocumentModal.FileName,
                enumUtil.enumValidationType.Required,
                'File Name',
            ),
            DocumentTypeVal: FormValidator(
                mainDocumentModal.DocumentTypeID,
                enumUtil.enumValidationType.Required,
                'Document Type',
            ),
            FileVal: FormValidator(
                mainDocumentModal.FileName,
                enumUtil.enumValidationType.Required,
                'File',
            ),
        }
        await setDocumetValidationModal(ValidationModal)
        valModal = ValidationModal
    }

    const addNewDocument = () => {
        setDocumentID('0');
        setMainDocumentModal(Document_Modal);
        setDocumetSaveUpdateModal({});
        removeFile();
        setfile(null)
        //   props.setDocumentID(null);
        //   handleCancelDocument();
        //   setDocumentID(null)
        //   handleClear();
    }

    // const handleClear = () => {
    //     setMainGoalsModal(Goals_Modal);
    //     setGoalsSaveUpdateModal({});
    // }

    const handleSaveDocument = async (type) => {
        await DocumentValidation()
        let validation = FormValidator([valModal], enumUtil.enumValidationType.NullCheck)
        if (validation) {
            NotificationHandler('Fill Required Fields', enumUtil.enumtoaster.error)
            return
        } else {
            // let data = { ...DocumetSaveUpdateModal };
            // const formData = new FormData();
            // formData.append('TableName', enumUtil.enumAPITableName.PatientDocument);
            // formData.append('ID', documentID);
            // formData.append('data[PatientID]', PateintIDR + "");
            // if (!isNull(file)) {
            //     formData.append('File', file);
            // }
            // for (var key in data) {
            //     formData.append(`data[${key}]`, data[key]);
            // }
            ////////////////
            if (props?.isOpenedFrom === 'SOAP') {

                // console.log("setAdditionalInfoData", documentModal, mainDocumentModal);
                // mainDocumentModal.map(doc => 
                //     doc.PatientDocumentID
                // )
                let { localFile, TableName, UpdatedBy, UpdateDate, ...localDoc} = documentModal;
                let saveData = {
                    ...localDoc,
                    ...DocumetSaveUpdateModal,
                    recordNoClient: props?.documentModal?.recordNoClient,
                    'PatientDocumentID': documentID,
                    'PatientID': PateintIDR + "",
                    // ...(file ? { 'DocumentPath': file } : { documentModal?.DocumentPath}),
                };
                // Ensure recordNoClient is set on unsaved documents, reuse if editing existing unsaved doc
                const isNew = isNull(documentID) || documentID === "";

                if (isNew) {
                    // If editing an existing unsaved doc, keep its recordNoClient
                    if (!saveData.recordNoClient) {
                        // If creating a new unsaved doc (no recordNoClient yet), generate once
                        saveData.recordNoClient = String(Date.now());
                    }
                } else {
                    // For saved docs, remove recordNoClient before sending to backend
                    delete saveData.recordNoClient;
                }

                // Now use the saveData with consistent recordNoClient
                props?.setAdditionalInfoData(prev => {
                    const encounterList = [...(prev.EncounterDocument || [])];

                    const mainViewObj = {
                        recordNoClient: saveData.recordNoClient || "",
                        ...documentModal,
                        ...saveData,
                        PatientDocumentID: documentID ?? "",
                        ...(DocumetSaveUpdateModal.DocumentTypeID
                            ? { DocumentTypeID: DocumetSaveUpdateModal.DocumentTypeID }
                            : {}),
                    };

                    let updatedList;

                    if (isNew) {
                        const exists = encounterList.some(d => d.recordNoClient === mainViewObj.recordNoClient);
                        updatedList = exists
                            ? encounterList.map(d =>
                                d.recordNoClient === mainViewObj.recordNoClient ? mainViewObj : d
                            )
                            : [...encounterList, mainViewObj];
                    } else {
                        updatedList = encounterList.map(d =>
                            d.PatientDocumentID === documentID ? mainViewObj : d
                        );
                    }

                    return {
                        ...prev,
                        EncounterDocument: updatedList,
                    };
                });

                props?.setSaveDocumentData(prev => {
                    let cleanSaveData = { ...saveData };

                    if (isNew) {
                        // Check if this unsaved doc already has a recordNoClient
                        if (!cleanSaveData.recordNoClient) {
                            // New unsaved doc, assign new recordNoClient
                            cleanSaveData.recordNoClient = String(Date.now());
                        }
                        // No backend ID yet
                        cleanSaveData.PatientDocumentID = "";
                    } else {
                        // Saved docs: remove recordNoClient before sending to backend
                        delete cleanSaveData.recordNoClient;
                        cleanSaveData.PatientDocumentID = documentID ?? "";
                    }

                    if (isNew) {
                        // Find existing unsaved doc by recordNoClient and update it
                        const existingIndex = prev.findIndex(
                            item => item.recordNoClient === cleanSaveData.recordNoClient
                        );

                        if (existingIndex !== -1) {
                            // Update existing unsaved doc
                            return prev.map((item, i) => (i === existingIndex ? { ...item, ...cleanSaveData } : item));
                        }

                        // Append new unsaved doc
                        return [...prev, cleanSaveData];
                    } else {
                        // Saved docs: update by PatientDocumentID or add if missing
                        const idExist = prev.some(doc => doc.PatientDocumentID === cleanSaveData.PatientDocumentID);

                        return idExist
                            ? prev.map(doc =>
                                doc.PatientDocumentID === cleanSaveData.PatientDocumentID ? cleanSaveData : doc
                            )
                            : [...prev, cleanSaveData];
                    }
                });


                console.log("isOpenedFromDocumentsformData", props?.isOpenedFrom, saveData, mainDocumentModal)
                if (type === "Add Another") {
                    addNewDocument();
                } else {
                    onClose();
                }
            }
        }
    }
    const ViewFile = () => {
        let file = documentModal?.localFile;
        if (!file) return;

        const type = file.type;
        // You can also use file.name to determine extension if needed

        if (type.includes("text")) {
            // 🔸 Text File (e.g. .txt)
            const reader = new FileReader();
            reader.onload = () => setTxtFile(reader.result);
            reader.readAsText(file);
        } else if (type.includes("image")) {
            // 🔸 Image File (e.g. .png, .jpg, .tiff)
            const objectURL = URL.createObjectURL(file);
            setImgFile(objectURL);
        } else if (type.includes("pdf")) {
            // 🔸 PDF File
            const objectURL = URL.createObjectURL(file);
            setPdfFile(objectURL);
        } else {
            // 🔸 Other Files (optional fallback)
            console.warn("Unsupported file type:", type);
        }

            setModalActive(true);
        // Store file for upload later
        // setLocalFile(file);
        };
    const savefile = (e) => {
        setDocumentModal(prev => ({ ...prev, localFile: e.target.files?.[0]}));
        DocumetSaveUpdateModal['FileName'] = e.target.files[0].name;
        mainDocumentModal['FileName'] = e.target.files[0].name;
        const file = e.target.files[0];
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onloadend = (event) => {
            const base64 = event.target.result.split("base64,")[1];
            setfile(base64);
            DocumetSaveUpdateModal['DocumentPath'] = base64;
        };
    }

    const ViewPdf = (data) => {
        console.log("ViewPdfDownload")
        setPdfFile(null)
        setTxtFile(null)
        setImgFile(null)
        setIsLoading(true)
        ServerRequestPublic(API_URL_Wasabi + "/DownloadFile", 'post', {
            "BucketPath": mainDocumentModal.DocumentPath
        }, 'Download').then((response) => {
            setIsLoading(false)
            console.log(response.type);
            if (response.type === 'application/txt') {
                const blob = response;
                const reader = new FileReader();
                reader.onload = () => {
                    const content = reader.result;
                    setTxtFile(content);
                };

                reader.readAsText(blob, 'utf-8');
            } else if (response.type === 'application/png') {
                const blob = response
                const objectURL = URL.createObjectURL(blob);
                setImgFile(objectURL)
            } else if (response.type === 'application/tiff') {

            }
            else {
                let file = new Blob([response]);
                const fileUrl = URL.createObjectURL(file);
                setPdfFile(fileUrl)
            }
            setModalActive(true)
        }).catch((error) => {
            setIsLoading(false)
            NotificationHandler('File Not Found', enumUtil.enumtoaster.error);
        })
    }

    const removeFile = () => {
        setPdfFile(null);
        setTxtFile(null);
        setImgFile(null);

        if (fileInputRef.current) {
            fileInputRef.current.value = null;
        }
        setfile(null);
        DocumetSaveUpdateModal['FileName'] = ''
        mainDocumentModal['FileName'] = ''
        DocumetSaveUpdateModal['DocumentPath'] = ''

        setMainDocumentModal(mainDocumentModal);
        setDocumetSaveUpdateModal(DocumetSaveUpdateModal);
    }
    useEffect(() => {
        setMainDocumentModal(Document_Modal)
        console.log("PatientDocumentID", PatientDocumentID)
        if (!isNull(PatientDocumentID)) {
            setDocumentID(PatientDocumentID)
            if (documentModal.DocumentTypeID) {
                setMainDocumentModal({ ...documentModal, DocumentTypeID: DropdownValueHandler(DropDowns.DocumentType, documentModal.DocumentTypeID) })
                setIs(true);
            }
        } else {
            setMainDocumentModal({
                ...Document_Modal, ...documentModal,
                ...(documentModal.DocumentTypeID ? { DocumentTypeID: DropdownValueHandler(DropDowns.DocumentType, documentModal.DocumentTypeID) } : {})
            })
            setIs(true);
        }
    }, [PatientDocumentID])
    const handleCancelDocument = () => {
        setDocumentID('0');
        setMainDocumentModal(Document_Modal);
        setDocumetSaveUpdateModal({});
        removeFile();
        setfile(null)
        // onCancel();
        onClose();
    }
    const handleSelectedData = (selectedData, name, type) => {
        let modal = { ...mainDocumentModal };
        if (type === 'client' && !isNull(selectedData)) {
            console.log(selectedData, name, type);
            if (name === 'DocumentTypeID') {
                modal[name] = selectedData.display
                DocumetSaveUpdateModal[name] = selectedData.code + "";
                DocumetSaveUpdateModal['DocumentTypeID'] = selectedData.value + "";
            }
            else if (name === 'BillingDocumentStatus') {
                modal[name] = selectedData.display
                DocumetSaveUpdateModal[name] = selectedData.value;
            }
        }
        else {
            modal[name] = ''
            DocumetSaveUpdateModal[name] = ''
        }
        setMainDocumentModal(modal)
        return selectedData
    }

    const AddDocument = () => {
        return (
            <p className="heading">Add Document</p>
        )
    }
    return (

        <Modal show={isOpenDocument} onHide={isOpenDocument} backdrop="static" keyboard={false} centered dialogClassName="hk-modal-v1 encounter_add_document">
            {isLoading ? <Loader /> : null}
            <Modal.Body>
                <ModalHeader HeaderName={AddDocument} DeletePopup={''} isClosed={onClose} />
                <div className="d-flex flex-column gap-12">
                    {console.log("mainDocumentModalmainDocumentModal", mainDocumentModal)}
                    {mainDocumentModal.FileName ? (
                        // <div className="upload-box__filePicker__fileInfo mt-1 d-flex align-items-center">
                        //     <p className='mb-0 heading' title={mainDocumentModal.FileName}>{mainDocumentModal.FileName}</p>
                        //     <i className='icon-delete' onClick={removeFile}>
                        //     </i>
                        //     <div className="btn-Container">
                        //         {/* {/ <button className="btn btn-sm text-success"  onClick={savefile}>Change</button> /}
                        //     {/ <button className="btn btn-sm text-danger" onClick={removeFile}>Remove</button> /} */}
                        //     </div>
                        // </div>
                        <div className="d-flex align-items-center gap-2">
                            <p className="heading lh-14" title={mainDocumentModal.FileName}>{mainDocumentModal.FileName}</p>
                            {documentModal?.localFile ? 
                            <i className="icon-Icon-awesome-eye fs-11" onClick={ViewFile}></i> :
                            (mainDocumentModal.DocumentPath && mainDocumentModal.PatientDocumentID) && <i className="icon-Icon-awesome-eye fs-11" onClick={ViewPdf}></i>}
                            <i className="icon-delete text-danger fs-12" onClick={removeFile}></i>
                        </div>
                    ) : (
                        <div className={DocumetValidationModal.FileVal ? 'form-group input error' : "form-group input mb-0"}>
                            <div className='d-flex'>
                                <input
                                    type="file"
                                    id='EncounterSOAPDocument'
                                    name="EncounterSOAPDocument"
                                    className='d-block opacity-0 w-100 position-absolute'
                                    accept=".png, .txt, .pdf, .tiff"
                                    onChange={savefile}
                                    ref={fileInputRef}
                                // accept=".jpg, .pdf "
                                //  accept="image/*,application/pdf,text/plain" 
                                />

                                <label className="d-flex align-items-center gap-5  px-2 w-100 text-nowrap cursor-pointe form-control justify-content-center" htmlFor='EncounterSOAPDocument'>
                                    <i className='icon-Icon-metro-attachment fs-12'></i>
                                    <p className='text fs-13 ar-light-color'>Upload a File</p>
                                </label>
                            </div>
                            {DocumetValidationModal.FileVal}
                        </div>
                    )}
                    {/* <div className='d-flex'>
                    <input
                        type="file"
                        id='EncounterSOAPDocument'
                        name="EncounterSOAPDocument"
                        className='d-block opacity-0 w-100 position-absolute'
                    />
                    <label className="d-flex align-items-center gap-5  px-2 w-100 text-nowrap cursor-pointe form-control justify-content-center" htmlFor='EncounterSOAPDocument'>
                        <i className='icon-Icon-metro-attachment fs-12'></i>
                        <p className='text fs-13 ar-light-color'>Upload a File</p>
                    </label>
                </div>
                <div className="d-flex align-items-center gap-2">
                    <p className="heading lh-14">qrcode_localhost.png</p>
                    <i className="icon-delete text-danger fs-12"></i>
                </div> */}
                    <div className="input mb-0 ">
                        <label className="pb-3px">File Name<span className='req'>*</span></label>
                        <div className={DocumetValidationModal.FileNameVal ? 'form-group input error' : 'form-group input'}>
                            <input
                                disabled
                                type="text"
                                className="form-control"
                                id="FileName"
                                name="FileName"
                                value={mainDocumentModal.FileName}
                                onChange={handleDocumentChange}
                                // disabled={mainDocumentModal.FileName === '' || mainDocumentModal.FileName === null}
                            />
                            {DocumetValidationModal.FileNameVal}
                        </div>
                    </div>
                    <div className="input mb-0">
                        <label className="pb-3px">Document Type<span className='req'>*</span></label>
                        <div className={DocumetValidationModal.DocumentTypeVal ? 'form-group input error  ar_palceholder' : 'form-group input  ar_palceholder'}>
                            <SuperSearchList
                                key={documentID}
                                type="client"
                                id='DocumentTypeID'
                                name='DocumentTypeID'
                                searchValue={mainDocumentModal.DocumentTypeID}
                                data={DropDowns?.DocumentType}
                                onChange={handleDocumentChange}
                                getSelectedData={handleSelectedData}
                                is={is}
                                sup_btn='sup_btn-Inp'
                                sup_inp='superSearchVisitInp'
                                inputError={DocumetValidationModal.DocumentTypeVal}
                            />
                            {DocumetValidationModal.DocumentTypeVal}
                        </div>
                    </div>
                    <div className="input mb-0 ">
                        <label className="pb-3px">Title</label>
                        <input
                            type="text"
                            className="form-control"
                            id="Title"
                            name="Title"
                            value={mainDocumentModal.Title}
                            onChange={handleDocumentChange}
                        />
                    </div>
                    <div className='input m-0'>
                        <label className="pb-3px">Description</label>
                        <textarea
                            className="form-control"
                            rows="3"
                            name="Description"
                            id="Description"
                            value={mainDocumentModal.Description}
                            onChange={handleDocumentChange}
                        ></textarea>
                    </div>
                    <div className='d-flex align-items-center gap-2'>
                        <p className='heading fs-11'>By: <span className='green-text'>{mainDocumentModal.UpdateDate || 'N/A'}</span></p>
                        <p className='text light-clrs'>|</p>
                        <p className='heading fs-11'>Date: <span className='green-text'>{mainDocumentModal.UpdatedBy || 'N/A'}</span></p>
                    </div>
                </div>
            </Modal.Body>

            {/* Document PDF Modal */}
            <Modal show={modalActive} onHide={() => setModalActive(false)} backdrop="static" keyboard={false} centered dialogClassName="app-modal modal-md hk-login-v1 hk-modal-v1">
                <Modal.Body>
                    <div className="download-header">
                        <div className='hide-me'></div>
                        {/* <button className="btn download-btn">
                      Download PDF
                    </button> */}

                        <button className="btn-icon-transparent" onClick={() => setModalActive(false)}>
                            <i className="icon-Icon-metro-cross"></i>
                        </button>
                    </div>
                    <div className="pdfView-box">

                        {!isNull(txtFile) ? txtFile : ''}
                        {!isNull(imgFile) ? <img src={imgFile} alt='Image' /> : ''}

                    </div>
                    {isLoading ? <Loader /> : null}

                    {pdfFile &&
                        <>
                            <Worker workerUrl="https://unpkg.com/pdfjs-dist@2.16.105/build/pdf.worker.min.js">
                                <Viewer fileUrl={pdfFile}
                                    defaultScale={1}
                                    plugins={[defaultLayoutPluginInstance]} />
                            </Worker>
                        </>
                    }
                </Modal.Body>
                <div className='btns-group text-end px-3 py-3 br-top-1 br-clr'>
                    <button className='btn btn-gray' onClick={() => setModalActive(false)}>Cancel</button>
                </div>
            </Modal>
            <div className='d-flex align-items-center pb-15 px-10 pt-2 br-top-1 za_br_light  ar_footer justify-content-between'>
                <button className='btn btn-outline  px-10 h-100 dark-clr ' onClick={handleCancelDocument}>Cancel</button>
                <div className="d-flex align-items-center gap-2">
                    <button className='btn btn-outline  px-10 h-100 validate-color' onClick={() => handleSaveDocument("Add Another")}>Save & Add Another</button>
                    <button className='btn btn-validate px-10 h-100' onClick={handleSaveDocument}>Save</button>
                </div>
            </div>
        </Modal>
    )
}

export default AddNewDocument